const WORDS = ["Rinasci", "Evolvi", "Investi", "SYNrise"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {[...WORDS, ...WORDS].map((w, i) => (
      <span key={i} className="flex items-center">
        <span className={`px-6 font-serif text-5xl italic sm:text-7xl ${i % 2 ? "text-outline" : "text-zinc-100"}`}>{w}</span>
        <span className="text-xl text-gold sm:text-2xl">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" aria-hidden="true" className="relative overflow-hidden border-y border-white/5 bg-surface/40 py-6 sm:py-8">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-ink to-transparent sm:w-32" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-ink to-transparent sm:w-32" />
  </div>
);
